import { render, staticRenderFns } from "./pages-tool.vue?vue&type=template&id=489a7c8a"
import script from "./pages-tool.vue?vue&type=script&lang=js"
export * from "./pages-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports